import { connect } from 'react-redux'
import { showModal } from 'redux/modules/modals'
import AdminCategoriesComponent from '../components/AdminCategoriesComponent'

const mapActionCreators = {
  showModal
}

const mapStateToProps = state => {
  return {
    categories: state.categories.list,
    taxes: state.settings.taxes
  }
}

export default connect(mapStateToProps, mapActionCreators)(
  AdminCategoriesComponent
)



// WEBPACK FOOTER //
// ./src/routes/Admin/Categories/containers/AdminCategoriesContainer.js